const personalityTests = [
	{
		path: '/jobs/personality-tests/list',
		name: 'jobs-personality-tests-list',
		component: () => import('@/views/jobs/personality-tests/list.vue'),
		meta: { layout: 'content', module: 'MGJ,personality-tests' },
	},
	{
		path: '/jobs/personality-tests/create',
		name: 'jobs-personality-tests-create',
		component: () => import('@/views/jobs/personality-tests/form.vue'),
		meta: { layout: 'content', module: 'MGJ,personality-tests' },
	},
	{
		path: '/jobs/personality-tests/edit/:id',
		name: 'jobs-personality-tests-edit',
		component: () => import('@/views/jobs/personality-tests/form.vue'),
		meta: { layout: 'content', module: 'MGJ,personality-tests' },
	},
	{
		path: '/jobs/personality-tests/:slug/detail',
		name: 'jobs-personality-tests-detail',
		component: () => import('@/views/jobs/personality-tests/detail.vue'),
		meta: { layout: 'content', module: 'MGJ,personality-tests' },
	},
	{
		path: '/jobs/personality-tests/sessions',
		name: 'jobs-personality-tests-sessions',
		component: () => import('@/views/jobs/personality-tests/sessions.vue'),
		meta: { layout: 'content', module: 'MGJ,personality-tests' },
	},
	{
		path: '/jobs/personality-tests/results',
		name: 'jobs-personality-tests-results',
		component: () => import('@/views/jobs/personality-tests/results.vue'),
		meta: { layout: 'content', module: 'MGJ,personality-tests' },
	},
	{
		path: '/jobs/personality-tests/assignments',
		name: 'jobs-personality-tests-assignments',
		component: () => import('@/views/jobs/personality-tests/assignments.vue'),
		meta: { layout: 'content', module: 'MGJ,personality-tests' },
	},
	{
		path: '/jobs/personality-tests/nurture',
		name: 'jobs-personality-tests-nurture',
		component: () => import('@/views/jobs/personality-tests/nurture.vue'),
		meta: { layout: 'content', module: 'MGJ,personality-tests' },
	},
]

export default personalityTests
